// @ts-nocheck
import { populate } from 'populate';
import type { Container, Graphics, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '8c355c05-4a1c-4b30-8204-0636a0e0f63a',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'e2170a90-8320-4e08-978c-517050031035',
      type: 'Graphics',
      name: 'overlay',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0.6,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '8c355c05-4a1c-4b30-8204-0636a0e0f63a',
      commands: [
        {
          id: '6ec6b15b-acca-4ce3-ab7a-eef2ce357912',
          type: 'beginFill',
          color: 0,
          alpha: 1
        },
        {
          id: '6d30e8c7-e594-4bf0-ac6c-2c80430dd7ac',
          type: 'drawRect',
          x: -2000,
          y: -2000,
          width: 4000,
          height: 4000
        },
        {
          id: '455bb6b2-f8f9-43a8-b8c2-489dcd247021',
          type: 'beginFill',
          color: 0,
          alpha: 1
        }
      ]
    },
    {
      id: 'c2d3ec78-888e-41d0-92e8-c7f79b0f5871',
      type: 'Sprite',
      name: 'rays',
      className: 'rotate_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3,
        y: 3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '8c355c05-4a1c-4b30-8204-0636a0e0f63a'
    },
    {
      id: '5b6e430e-1eb6-4d32-9af9-1e76d6942813',
      type: 'Container',
      name: 'fxContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '8c355c05-4a1c-4b30-8204-0636a0e0f63a'
    },
    {
      id: '6db06678-e419-4d56-8b54-387da7079cb6',
      type: 'Sprite',
      name: 'changeArrow',
      className: '',
      x: 0,
      y: 400,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Big_Flag_Arrow_Green',
      parent: '8c355c05-4a1c-4b30-8204-0636a0e0f63a'
    },
    {
      id: '1d4bc522-4874-45c1-ae45-2ef967f1ddec',
      type: 'Container',
      name: 'flagContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '8c355c05-4a1c-4b30-8204-0636a0e0f63a'
    },
    {
      id: '9e4daec0-df4f-403a-8182-59e82cb03618',
      type: 'Sprite',
      name: 'flagSide',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Big_Flag_Back_Bottom',
      parent: '8c355c05-4a1c-4b30-8204-0636a0e0f63a'
    },
    {
      id: '7dbadd10-ffa0-4f44-82c0-5b49cacf8b60',
      type: 'Sprite',
      name: 'flagDepthSprite',
      className: '',
      x: 0,
      y: 23,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Big_Flag_Back',
      parent: '1d4bc522-4874-45c1-ae45-2ef967f1ddec'
    },
    {
      id: '46c7f429-382a-4672-9e3d-abeca7af9f41',
      type: 'Sprite',
      name: 'flagSprite',
      className: '',
      x: 0,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Big_Flag_Green',
      parent: '1d4bc522-4874-45c1-ae45-2ef967f1ddec',
      stateByName: {
        '2nd': {
          texture: 'Race_Event_Flag_2nd'
        },
        '3rd': {
          texture: 'Race_Event_Flag_3rd'
        }
      }
    },
    {
      id: 'a6ea75bd-5eb4-4d2d-b3d1-39296823d086',
      type: 'Text',
      name: 'redRankText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1st',
      localize: false,
      maxWidth: 200,
      maxHeight: 300,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 120,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#73191F',
        strokeThickness: 20,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '1d4bc522-4874-45c1-ae45-2ef967f1ddec',
      stateByName: {
        '2nd': {
          text: '2nd',
          style: {
            stroke: '#024da0'
          }
        },
        '3rd': {
          text: '3rd',
          style: {
            stroke: '#9a422a'
          }
        }
      }
    },
    {
      id: 'eebb7425-6055-450d-8d9a-0715dc311b05',
      type: 'Text',
      name: 'greenRankText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1st',
      localize: false,
      maxWidth: 200,
      maxHeight: 300,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 120,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#2D7720',
        strokeThickness: 20,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '1d4bc522-4874-45c1-ae45-2ef967f1ddec',
      stateByName: {
        '2nd': {
          text: '2nd',
          style: {
            stroke: '#024da0'
          }
        },
        '3rd': {
          text: '3rd',
          style: {
            stroke: '#9a422a'
          }
        }
      }
    },
    {
      id: '7e445977-bc91-40de-ba01-e818fcaf4745',
      type: 'Sprite',
      name: 'flagOverlay',
      className: '',
      x: 0,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Big_Flag_Green',
      parent: '1d4bc522-4874-45c1-ae45-2ef967f1ddec'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  stateNames: [
    '2nd',
    '3rd'
  ],
  animations: [
    {
      id: '2344750d-42da-4cda-9285-78b4b0cbf595',
      name: 'Rank_Increase',
      playingSpeed: 1,
      totalDuration: 2000,
      blocks: [
        {
          id: 'b226c587-6e04-4088-a3c1-e3a35e3b647a',
          type: 'Setter',
          name: 'overlaySetter',
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'overlay',
          disabled: false
        },
        {
          id: 'ecde9e5d-0d7c-4482-b8ba-bbc2b80ec178',
          type: 'Setter',
          name: 'arrowSetter',
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'changeArrow',
          disabled: false
        },
        {
          id: '270f1646-aa8e-41ea-9650-24122f16b07c',
          type: 'Setter',
          name: 'raysSetter',
          track: 2,
          target: {
            alpha: 0,
            tint: 5828872
          },
          startAt: 0,
          sourceName: 'rays',
          disabled: false
        },
        {
          id: '787d2091-08f4-4bda-bb09-ad07f670270f',
          type: 'Setter',
          name: 'flagSetter',
          track: 4,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'flagContainer',
          disabled: false
        },
        {
          id: '88333a26-f420-4bd7-85d9-31e0106fedd5',
          type: 'Setter',
          name: 'redRankText_alpha',
          track: 16,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'redRankText',
          disabled: false
        },
        {
          id: 'e857e8d5-73d0-40ef-84a0-5f4069765f7a',
          type: 'Setter',
          name: 'greenText_alpha',
          track: 12,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'greenRankText',
          disabled: false
        },
        {
          id: '275da55f-b901-4666-8a29-d396d7580682',
          type: 'Setter',
          name: 'flag_sprite',
          track: 14,
          target: {
            textureName: 'Race_Event_Big_Flag_Red'
          },
          startAt: 0,
          sourceName: 'flagSprite',
          disabled: false
        },
        {
          id: '4abb98a9-d29d-4bf2-b4ef-2b9a6bf3ed7f',
          type: 'Tween',
          name: 'overlayAlpha',
          duration: 300,
          track: 8,
          target: {
            alpha: 0.8
          },
          startAt: 0,
          sourceName: 'overlay',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '5a7ddb7b-df68-414e-9d7a-3a8928a9280f',
          type: 'Tween',
          name: 'overlayAlpha_1',
          duration: 300,
          track: 6,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'rays',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '8e3a1edb-10f7-4f94-aee0-5b43c65eaf07',
          type: 'Tween',
          name: 'New_tween',
          duration: 300,
          track: 1,
          target: {},
          startAt: 0,
          sourceName: 'root',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'a2ed63a6-f769-4adc-89e7-3132a01c30b9',
          type: 'Tween',
          name: 'flagScaleIn',
          duration: 400,
          track: 12,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 107,
          sourceName: 'flagContainer',
          easing: 'BackOut',
          disabled: false
        },
        {
          id: 'de8a2a37-ec8f-45b0-8a55-d6ce89500746',
          type: 'Tween',
          name: 'arrowAlpha',
          duration: 200,
          track: 10,
          target: {
            alpha: 1
          },
          startAt: 477,
          sourceName: 'changeArrow',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '41ef1948-d7a5-4fff-97f3-8a6e10ab66d4',
          type: 'Tween',
          name: 'arrowPosition',
          duration: 1000,
          track: 9,
          target: {
            y: -400,
            scale: {}
          },
          startAt: 477,
          sourceName: 'changeArrow',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '6f42bcd6-1b1a-4638-9dd4-8601f3ad4270',
          type: 'Tween',
          name: 'flagScaleIn_copy',
          duration: 200,
          track: 12,
          target: {
            scale: {
              x: 1.1,
              y: 1
            }
          },
          startAt: 507,
          sourceName: 'flagContainer',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: 'f126cd1b-a991-4f90-a86c-d84ca7c22d7b',
          type: 'Setter',
          name: 'FXPART_Race_Event_Arrow_Particles_Green',
          track: 17,
          target: {},
          startAt: 699,
          sourceName: 'fxContainer',
          disabled: false
        },
        {
          id: 'dcb6245c-025c-45f2-a33b-20f305dabfd4',
          type: 'Tween',
          name: 'flagScaleIn_copy_copy',
          duration: 200,
          track: 22,
          target: {
            scale: {
              y: 0.2
            },
            angle: 0
          },
          startAt: 738,
          sourceName: 'flagContainer',
          easing: 'CubicIn',
          disabled: false
        },
        {
          id: 'f0d55260-89d5-4574-b3d8-554e683d3f63',
          type: 'Tween',
          name: 'flagScaleIn_copy_copy_copy',
          duration: 200,
          track: 18,
          target: {
            scale: {
              y: 1.7
            },
            y: 70
          },
          startAt: 740,
          sourceName: 'flagDepthSprite',
          easing: 'QuarticIn',
          disabled: false
        },
        {
          id: '849f4007-7e03-4d6d-889d-9da80085896d',
          type: 'Setter',
          name: 'New_setter_copy',
          track: 20,
          target: {
            alpha: 0
          },
          startAt: 937,
          sourceName: 'flagContainer',
          disabled: false
        },
        {
          id: 'ccce43b1-b5c5-4341-be16-ec1862e963a3',
          type: 'Setter',
          name: 'New_setter',
          track: 22,
          target: {
            alpha: 1
          },
          startAt: 938,
          sourceName: 'flagSide',
          disabled: false
        },
        {
          id: 'd48d4add-8cfb-4d98-b577-5db7aab2516f',
          type: 'Tween',
          name: 'flagScaleIn_copy_copy_copy_copy_copy_copy',
          duration: 260,
          track: 15,
          target: {
            scale: {},
            alpha: 0.5
          },
          startAt: 949,
          sourceName: 'flagOverlay',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '9b953a02-df84-467a-a2e4-fce2423da963',
          type: 'Setter',
          name: 'redRankText_alpha_copy',
          track: 16,
          target: {
            alpha: 0
          },
          startAt: 957,
          sourceName: 'redRankText',
          disabled: false
        },
        {
          id: '72f503db-6df3-490a-a976-f9b97cedce56',
          type: 'Setter',
          name: 'greenText_alpha_copy',
          track: 12,
          target: {
            alpha: 1
          },
          startAt: 958,
          sourceName: 'greenRankText',
          disabled: false
        },
        {
          id: 'c60989e2-97c9-4c3d-a52f-5ade3a9bf560',
          type: 'Setter',
          name: 'flag_sprite_copy',
          track: 14,
          target: {
            textureName: 'Race_Event_Big_Flag_Green'
          },
          startAt: 962,
          sourceName: 'flagSprite',
          disabled: false
        },
        {
          id: 'a9b51e85-8bb3-400d-ba4e-f4b2a4786e12',
          type: 'Setter',
          name: 'flag_sprite_copy_copy',
          track: 13,
          target: {
            textureName: 'Race_Event_Big_Flag_Green'
          },
          startAt: 962,
          sourceName: 'flagOverlay',
          disabled: false
        },
        {
          id: '01eb0643-4a43-46d0-a68f-5ec6e3697fb4',
          type: 'Tween',
          name: 'flagScaleIn_copy_copy_copy_copy_copy',
          duration: 200,
          track: 18,
          target: {
            scale: {
              y: 1
            },
            y: 23
          },
          startAt: 1010,
          sourceName: 'flagDepthSprite',
          easing: 'QuarticOut',
          disabled: false
        },
        {
          id: '868d9b48-2631-40ca-9f27-9a5f8a7086a0',
          type: 'Setter',
          name: 'New_setter_copy_1',
          track: 22,
          target: {
            alpha: 0
          },
          startAt: 1011,
          sourceName: 'flagSide',
          disabled: false
        },
        {
          id: 'e538c343-1792-41e0-ad80-7a9ebd3c8315',
          type: 'Setter',
          name: 'New_setter_copy_copy',
          track: 20,
          target: {
            alpha: 1
          },
          startAt: 1012,
          sourceName: 'flagContainer',
          disabled: false
        },
        {
          id: '05df890f-9399-408b-b3b9-d7e5cfca90d4',
          type: 'Tween',
          name: 'flagScaleIn_copy_copy_copy_1',
          duration: 200,
          track: 22,
          target: {
            scale: {
              y: 1.2,
              x: 0.9
            },
            angle: 0
          },
          startAt: 1012,
          sourceName: 'flagContainer',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: 'aa30339c-828c-4160-9790-9599b49fe0eb',
          type: 'Tween',
          name: 'flagScaleIn_copy_copy_copy_copy_copy_copy_copy',
          duration: 200,
          track: 15,
          target: {
            scale: {},
            alpha: 0
          },
          startAt: 1210,
          sourceName: 'flagOverlay',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '1ceb1c34-8ae8-4696-8dd1-c684e3cbd58b',
          type: 'Tween',
          name: 'flagScaleIn_copy_copy_copy_1_copy',
          duration: 200,
          track: 22,
          target: {
            scale: {
              y: 1,
              x: 1
            },
            angle: 0
          },
          startAt: 1212,
          sourceName: 'flagContainer',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '9134204f-fbed-432d-8099-1977e9592d3b',
          type: 'Tween',
          name: 'arrowAlpha_copy',
          duration: 200,
          track: 10,
          target: {
            alpha: 0
          },
          startAt: 1277,
          sourceName: 'changeArrow',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '06bfba1d-a170-4ff7-8f91-d482eb769ef0',
          type: 'Setter',
          name: 'ANIMEVENT_startTransition',
          track: 11,
          target: {},
          startAt: 1630,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '1ca33308-cbf4-4072-bc1c-6cf03be706ee',
          type: 'Tween',
          name: 'overlayAlpha_1_copy',
          duration: 300,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 1700,
          sourceName: 'rays',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '2d919ca9-cada-4bb5-8398-c5aaadad6b0e',
          type: 'Tween',
          name: 'overlayAlpha_copy_1',
          duration: 300,
          track: 8,
          target: {
            alpha: 0
          },
          startAt: 1701,
          sourceName: 'overlay',
          easing: 'SinusoidalIn',
          disabled: false
        }
      ]
    },
    {
      id: 'c733e3d9-0997-46ab-8db3-5b41ee0acd8d',
      name: 'Rank_Decrease',
      playingSpeed: 1,
      totalDuration: 2000,
      blocks: [
        {
          id: 'b226c587-6e04-4088-a3c1-e3a35e3b647a',
          type: 'Setter',
          name: 'overlaySetter',
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'overlay',
          disabled: false
        },
        {
          id: 'ecde9e5d-0d7c-4482-b8ba-bbc2b80ec178',
          type: 'Setter',
          name: 'arrowSetter',
          track: 3,
          target: {
            alpha: 0,
            textureName: 'Race_Event_Big_Flag_Arrow_Red',
            y: -400
          },
          startAt: 0,
          sourceName: 'changeArrow',
          disabled: false
        },
        {
          id: '270f1646-aa8e-41ea-9650-24122f16b07c',
          type: 'Setter',
          name: 'raysSetter',
          track: 2,
          target: {
            alpha: 0,
            tint: 15796232
          },
          startAt: 0,
          sourceName: 'rays',
          disabled: false
        },
        {
          id: '787d2091-08f4-4bda-bb09-ad07f670270f',
          type: 'Setter',
          name: 'flagSetter',
          track: 4,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'flagContainer',
          disabled: false
        },
        {
          id: '88333a26-f420-4bd7-85d9-31e0106fedd5',
          type: 'Setter',
          name: 'redRankText_alpha',
          track: 16,
          target: {
            alpha: 0,
            textureName: ''
          },
          startAt: 0,
          sourceName: 'redRankText',
          disabled: false
        },
        {
          id: 'e857e8d5-73d0-40ef-84a0-5f4069765f7a',
          type: 'Setter',
          name: 'greenText_alpha',
          track: 12,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'greenRankText',
          disabled: false
        },
        {
          id: '275da55f-b901-4666-8a29-d396d7580682',
          type: 'Setter',
          name: 'flag_sprite',
          track: 14,
          target: {
            textureName: 'Race_Event_Big_Flag_Green'
          },
          startAt: 0,
          sourceName: 'flagSprite',
          disabled: false
        },
        {
          id: '4abb98a9-d29d-4bf2-b4ef-2b9a6bf3ed7f',
          type: 'Tween',
          name: 'overlayAlpha',
          duration: 300,
          track: 8,
          target: {
            alpha: 0.8
          },
          startAt: 0,
          sourceName: 'overlay',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '5a7ddb7b-df68-414e-9d7a-3a8928a9280f',
          type: 'Tween',
          name: 'overlayAlpha_1',
          duration: 300,
          track: 6,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'rays',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '8e3a1edb-10f7-4f94-aee0-5b43c65eaf07',
          type: 'Tween',
          name: 'New_tween',
          duration: 300,
          track: 1,
          target: {},
          startAt: 0,
          sourceName: 'root',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'a2ed63a6-f769-4adc-89e7-3132a01c30b9',
          type: 'Tween',
          name: 'flagScaleIn',
          duration: 400,
          track: 12,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 107,
          sourceName: 'flagContainer',
          easing: 'BackOut',
          disabled: false
        },
        {
          id: 'de8a2a37-ec8f-45b0-8a55-d6ce89500746',
          type: 'Tween',
          name: 'arrowAlpha',
          duration: 200,
          track: 10,
          target: {
            alpha: 1
          },
          startAt: 477,
          sourceName: 'changeArrow',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '41ef1948-d7a5-4fff-97f3-8a6e10ab66d4',
          type: 'Tween',
          name: 'arrowPosition',
          duration: 1000,
          track: 9,
          target: {
            y: 400,
            scale: {}
          },
          startAt: 477,
          sourceName: 'changeArrow',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '6f42bcd6-1b1a-4638-9dd4-8601f3ad4270',
          type: 'Tween',
          name: 'flagScaleIn_copy',
          duration: 200,
          track: 12,
          target: {
            scale: {
              x: 1.1,
              y: 1
            }
          },
          startAt: 507,
          sourceName: 'flagContainer',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '91d8c5ca-d142-4a66-ac42-847932b4f25f',
          type: 'Setter',
          name: 'FXPART_Race_Event_Arrow_Particles_Red',
          track: 17,
          target: {},
          startAt: 701,
          sourceName: 'fxContainer',
          disabled: false
        },
        {
          id: 'dcb6245c-025c-45f2-a33b-20f305dabfd4',
          type: 'Tween',
          name: 'flagScaleIn_copy_copy',
          duration: 200,
          track: 22,
          target: {
            scale: {
              y: 0.2
            },
            angle: 0
          },
          startAt: 738,
          sourceName: 'flagContainer',
          easing: 'CubicIn',
          disabled: false
        },
        {
          id: 'f0d55260-89d5-4574-b3d8-554e683d3f63',
          type: 'Tween',
          name: 'flagScaleIn_copy_copy_copy',
          duration: 200,
          track: 18,
          target: {
            scale: {
              y: 1.7
            },
            y: 70
          },
          startAt: 740,
          sourceName: 'flagDepthSprite',
          easing: 'QuarticIn',
          disabled: false
        },
        {
          id: '849f4007-7e03-4d6d-889d-9da80085896d',
          type: 'Setter',
          name: 'New_setter_copy',
          track: 20,
          target: {
            alpha: 0
          },
          startAt: 937,
          sourceName: 'flagContainer',
          disabled: false
        },
        {
          id: 'ccce43b1-b5c5-4341-be16-ec1862e963a3',
          type: 'Setter',
          name: 'New_setter',
          track: 22,
          target: {
            alpha: 1
          },
          startAt: 938,
          sourceName: 'flagSide',
          disabled: false
        },
        {
          id: '9b953a02-df84-467a-a2e4-fce2423da963',
          type: 'Setter',
          name: 'redRankText_alpha_copy',
          track: 16,
          target: {
            alpha: 1
          },
          startAt: 957,
          sourceName: 'redRankText',
          disabled: false
        },
        {
          id: '72f503db-6df3-490a-a976-f9b97cedce56',
          type: 'Setter',
          name: 'greenText_alpha_copy',
          track: 12,
          target: {
            alpha: 0
          },
          startAt: 958,
          sourceName: 'greenRankText',
          disabled: false
        },
        {
          id: 'c60989e2-97c9-4c3d-a52f-5ade3a9bf560',
          type: 'Setter',
          name: 'flag_sprite_copy',
          track: 14,
          target: {
            textureName: 'Race_Event_Big_Flag_Red'
          },
          startAt: 962,
          sourceName: 'flagSprite',
          disabled: false
        },
        {
          id: 'a9b51e85-8bb3-400d-ba4e-f4b2a4786e12',
          type: 'Setter',
          name: 'flag_sprite_copy_copy',
          track: 13,
          target: {
            textureName: 'Race_Event_Big_Flag_Red'
          },
          startAt: 962,
          sourceName: 'flagOverlay',
          disabled: false
        },
        {
          id: '01eb0643-4a43-46d0-a68f-5ec6e3697fb4',
          type: 'Tween',
          name: 'flagScaleIn_copy_copy_copy_copy_copy',
          duration: 200,
          track: 18,
          target: {
            scale: {
              y: 1
            },
            y: 23
          },
          startAt: 1010,
          sourceName: 'flagDepthSprite',
          easing: 'QuarticOut',
          disabled: false
        },
        {
          id: '868d9b48-2631-40ca-9f27-9a5f8a7086a0',
          type: 'Setter',
          name: 'New_setter_copy_1',
          track: 22,
          target: {
            alpha: 0
          },
          startAt: 1011,
          sourceName: 'flagSide',
          disabled: false
        },
        {
          id: 'e538c343-1792-41e0-ad80-7a9ebd3c8315',
          type: 'Setter',
          name: 'New_setter_copy_copy',
          track: 20,
          target: {
            alpha: 1
          },
          startAt: 1012,
          sourceName: 'flagContainer',
          disabled: false
        },
        {
          id: '05df890f-9399-408b-b3b9-d7e5cfca90d4',
          type: 'Tween',
          name: 'flagScaleIn_copy_copy_copy_1',
          duration: 200,
          track: 22,
          target: {
            scale: {
              y: 1.2,
              x: 0.9
            },
            angle: 0
          },
          startAt: 1012,
          sourceName: 'flagContainer',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '1ceb1c34-8ae8-4696-8dd1-c684e3cbd58b',
          type: 'Tween',
          name: 'flagScaleIn_copy_copy_copy_1_copy',
          duration: 200,
          track: 22,
          target: {
            scale: {
              y: 1,
              x: 1
            },
            angle: 0
          },
          startAt: 1212,
          sourceName: 'flagContainer',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '9134204f-fbed-432d-8099-1977e9592d3b',
          type: 'Tween',
          name: 'arrowAlpha_copy',
          duration: 200,
          track: 10,
          target: {
            alpha: 0
          },
          startAt: 1277,
          sourceName: 'changeArrow',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '06bfba1d-a170-4ff7-8f91-d482eb769ef0',
          type: 'Setter',
          name: 'ANIMEVENT_startTransition',
          track: 11,
          target: {},
          startAt: 1630,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '1ca33308-cbf4-4072-bc1c-6cf03be706ee',
          type: 'Tween',
          name: 'overlayAlpha_1_copy',
          duration: 300,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 1700,
          sourceName: 'rays',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '2d919ca9-cada-4bb5-8398-c5aaadad6b0e',
          type: 'Tween',
          name: 'overlayAlpha_copy_1',
          duration: 300,
          track: 8,
          target: {
            alpha: 0
          },
          startAt: 1701,
          sourceName: 'overlay',
          easing: 'SinusoidalIn',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class RaceEventBigRankFlagLayout {
  static raw = raw;
  root!: Container;
  overlay!: Graphics;
  rays!: Sprite;
  fxContainer!: Container;
  changeArrow!: Sprite;
  flagContainer!: Container;
  flagSide!: Sprite;
  flagDepthSprite!: Sprite;
  flagSprite!: Sprite;
  redRankText!: Text;
  greenRankText!: Text;
  flagOverlay!: Sprite;
  rotate_SPL!: (Sprite)[];
  StateName!: '2nd' | '3rd';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Rank_Increase {
  Layout: {
    overlay: object;
    changeArrow: object;
    rays: object;
    flagContainer: object;
    redRankText: object;
    greenRankText: object;
    flagSprite: object;
    root: object;
    fxContainer: object;
    flagDepthSprite: object;
    flagSide: object;
    flagOverlay: object;
  };

  BlockTypeByName: {
    overlaySetter: object;
    arrowSetter: object;
    raysSetter: object;
    flagSetter: object;
    redRankText_alpha: object;
    greenText_alpha: object;
    flag_sprite: object;
    overlayAlpha: object;
    overlayAlpha_1: object;
    New_tween: object;
    flagScaleIn: object;
    arrowAlpha: object;
    arrowPosition: object;
    flagScaleIn_copy: object;
    FXPART_Race_Event_Arrow_Particles_Green: object;
    flagScaleIn_copy_copy: object;
    flagScaleIn_copy_copy_copy: object;
    New_setter_copy: object;
    New_setter: object;
    flagScaleIn_copy_copy_copy_copy_copy_copy: object;
    redRankText_alpha_copy: object;
    greenText_alpha_copy: object;
    flag_sprite_copy: object;
    flag_sprite_copy_copy: object;
    flagScaleIn_copy_copy_copy_copy_copy: object;
    New_setter_copy_1: object;
    New_setter_copy_copy: object;
    flagScaleIn_copy_copy_copy_1: object;
    flagScaleIn_copy_copy_copy_copy_copy_copy_copy: object;
    flagScaleIn_copy_copy_copy_1_copy: object;
    arrowAlpha_copy: object;
    ANIMEVENT_startTransition: object;
    overlayAlpha_1_copy: object;
    overlayAlpha_copy_1: object;
  };

  flowData = raw.animations[0];
}

export abstract class Rank_Decrease {
  Layout: {
    overlay: object;
    changeArrow: object;
    rays: object;
    flagContainer: object;
    redRankText: object;
    greenRankText: object;
    flagSprite: object;
    root: object;
    fxContainer: object;
    flagDepthSprite: object;
    flagSide: object;
    flagOverlay: object;
  };

  BlockTypeByName: {
    overlaySetter: object;
    arrowSetter: object;
    raysSetter: object;
    flagSetter: object;
    redRankText_alpha: object;
    greenText_alpha: object;
    flag_sprite: object;
    overlayAlpha: object;
    overlayAlpha_1: object;
    New_tween: object;
    flagScaleIn: object;
    arrowAlpha: object;
    arrowPosition: object;
    flagScaleIn_copy: object;
    FXPART_Race_Event_Arrow_Particles_Red: object;
    flagScaleIn_copy_copy: object;
    flagScaleIn_copy_copy_copy: object;
    New_setter_copy: object;
    New_setter: object;
    redRankText_alpha_copy: object;
    greenText_alpha_copy: object;
    flag_sprite_copy: object;
    flag_sprite_copy_copy: object;
    flagScaleIn_copy_copy_copy_copy_copy: object;
    New_setter_copy_1: object;
    New_setter_copy_copy: object;
    flagScaleIn_copy_copy_copy_1: object;
    flagScaleIn_copy_copy_copy_1_copy: object;
    arrowAlpha_copy: object;
    ANIMEVENT_startTransition: object;
    overlayAlpha_1_copy: object;
    overlayAlpha_copy_1: object;
  };

  flowData = raw.animations[1];
}
